import { z } from "zod";
export const createOrganisationOnSignupSchema = z.object({
    name: z.string().min(1, "Company name is required"),
    industry: z.string().min(1, "Industry is required"),
    website: z
        .string()
        .optional()
        .nullable()
        .default(null)
        .or(z.string().url("Website must be a valid URL")),
});
